import React from 'react';
import './Education.css'

const Education = () => {
  return (
    <div className='Education'>
      <h2 className='Education__header'>Education</h2>   
      <div className='Education__line'></div> 
      <h3 className='Education__years'>2005 - 2010</h3>
      <p className='Education__info'>Belarusian National Technical University, faculty of Instrument Engineering, department of Information Measuring Devices and Technologies, speciality is Methods and Devices for Quality Control and Objects Condition Diagnostics.</p>
    </div>
  )
}

export default Education